import * as React from 'react';

import InsightsReportsQueriesModalCollabaryInstagram from '../instagram/modals/InsightsReportsQueriesModalCollabaryInstagram';

import type {
  QueryChannel,
  QueryFieldType,
  QueryKeyword,
  QueryModalErrors,
  QueryModalTextFields,
  QueryStep
} from 'modules/insights/reports/types';

type Props = {
  stepIndex: number,
  stepCount: number,
  stepInfo: QueryStep,
  textFields: QueryModalTextFields,
  errors: QueryModalErrors,
  isShowingKpis: boolean,
  onRenderActionButton: () => React.ReactNode,
  onRenderBackButton: () => React.ReactNode,
  onRenderCancelButton: () => React.ReactNode,
  onTextFieldChange: (fieldType: QueryFieldType, value: string) => void,
  onHashtagsFieldChange: (value: Array<QueryKeyword>) => void,
  onChannelsFieldChange: (channels: Array<QueryChannel>) => void,
  onShowKpisToggle: () => void
};

class InsightsReportsQueriesModalCollabary extends React.PureComponent<Props> {
  renderInstagram(): React.ReactNode {
    const {
      stepIndex,
      stepCount,
      stepInfo,
      textFields,
      errors,
      isShowingKpis,
      onRenderActionButton,
      onRenderCancelButton,
      onRenderBackButton,
      onTextFieldChange,
      onHashtagsFieldChange,
      onChannelsFieldChange,
      onShowKpisToggle
    } = this.props;

    return (
      <div className="insights-reports-queries-modal-collabary__instagram">
        <InsightsReportsQueriesModalCollabaryInstagram
          stepIndex={stepIndex}
          stepCount={stepCount}
          stepInfo={stepInfo}
          textFields={textFields}
          errors={errors}
          isShowingKpis={isShowingKpis}
          onRenderActionButton={onRenderActionButton}
          onRenderCancelButton={onRenderCancelButton}
          onRenderBackButton={onRenderBackButton}
          onTextFieldChange={onTextFieldChange}
          onHashtagsFieldChange={onHashtagsFieldChange}
          onChannelsFieldChange={onChannelsFieldChange}
          onShowKpisToggle={onShowKpisToggle}
        />
      </div>
    );
  }

  render(): React.ReactNode {
    return (
      <div className="insights-reports-queries-modal-collabary">
        {this.renderInstagram()}
      </div>
    );
  }
}

export default InsightsReportsQueriesModalCollabary;
